import classNames from 'classnames';
import React from 'react';
import * as styles from './MetaList.module.scss';

interface MetaListProps {
  children: React.ReactNode;
  className?: string;
}

const MetaList = ({ children = null, className }: MetaListProps) => (
  <ul className={classNames(styles.metaList, className)}>{children}</ul>
);

export default MetaList;

interface MetaListItemProps {
  children: React.ReactNode;
  delimiter?: string | null;
}

export const MetaListItem = ({
  children,
  delimiter = '·',
}: MetaListItemProps) => <li data-delimiter={delimiter}>{children}</li>;
